import { render, staticRenderFns } from "./result-info-card.vue?vue&type=template&id=0663bb57&scoped=true"
import script from "./result-info-card.vue?vue&type=script&lang=js"
export * from "./result-info-card.vue?vue&type=script&lang=js"
import style0 from "./result-info-card.vue?vue&type=style&index=0&id=0663bb57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0663bb57",
  null
  
)

export default component.exports